import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import React, { InputHTMLAttributes } from 'react';
import { classNames } from '../../utils/class-names';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

const Input: React.FC<InputProps> = ({
  id,
  name,
  type,
  autoComplete,
  required,
  value,
  error,
  onChange,
  onBlur,
  placeholder,
}) => {
  return (
    <>
      <div className="relative rounded-md shadow-xs">
        <input
          id={id}
          name={name}
          type={type}
          autoComplete={autoComplete}
          required={required}
          className={classNames(
            !!error
              ? 'text-red-900 border-red-300 placeholder-red-300 pr-10 focus:border-red-500 focus:ring-red-500 '
              : 'border-gray-300 placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500',
            'appearance-none block w-full px-3 py-2 border rounded-md shadow-xs focus:outline-hidden sm:text-sm'
          )}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        {error && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true" />
          </div>
        )}
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600 m-0" id="email-error">
          {error}
        </p>
      )}
    </>
  );
};

export default Input;
